import {useEffect, useState} from 'react';
import { useFetchPostDataV2, setPath } from './useFetchData'
import {useQueryParams} from './useLocationData'
import homepageMapping from '../data/mapping/pages/homepageMapping';
import homepageMockData from '../data/homepage.json';
import homepageRequest from '../data/requests/homepageRequest.json';

const useHomepageData = () => {

    const queryKey = 'homepageData';
    const queryParams = useQueryParams();
    const isMockData = queryParams.get('useMockData') === 'true';
    const requestBody = setPath(homepageRequest, '/') ;

    const [homeData, setGlobalData] = useState('');

    const { isLoading, error, data } = useFetchPostDataV2(queryKey, requestBody, isMockData);
    useEffect(() => {
        if (data && !isMockData) {
            const mappedData = homepageMapping(data);
            setGlobalData(mappedData);
        }
    }, [data, isMockData])

    if (isMockData) {
      return { error:false, isLoading:false, homeData:homepageMockData};
    }

    return  { error, isLoading, homeData};
}

export default useHomepageData;
